var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('certificates-info',{attrs:{"name":"Madrobots","url":"madrobots.ru","type":"v1","size":"md","additional-icon":"external","catalog-path":{ name: 'Catalog' }}})}
var staticRenderFns = []

export { render, staticRenderFns }